import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './admin-portal-theme.css';
import App from './App';
import { applyPortalThemeFromStorage } from './utils/portalTheme';
import { bootstrapTenantBranding } from './utils/tenantBranding';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Cookies from 'js-cookie';

import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GRAPHQL_HTTP_URL } from './config/api';

applyPortalThemeFromStorage();
bootstrapTenantBranding();

// ── Auth link: attach JWT from cookie on every request ────────────────────────
const authLink = setContext((_, { headers }) => {
  const token = Cookies.get('accessToken');
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

const httpLink = new HttpLink({
  uri: GRAPHQL_HTTP_URL,
});

// ✅ Initialize Apollo Client with auth + http link
const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
});

// ✅ Render app inside ApolloProvider
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    {/* basename = '' in dev (PUBLIC_URL empty) and '/admin' in prod build */}
    <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
      <App />
    </BrowserRouter>
  </ApolloProvider>,
);

reportWebVitals();
